module.exports = __webpack_public_path__ + "img/carrusel_3.7b9bee15.png";